import React from 'react';

import { StyledButton } from '../../FileUploader/FileUploader.styles';
import { Icon } from '../Icon';
import { PaginationContainer } from './Pagintion.styles';

const PAGINATION_PAGE = 10;

function getPageNumbers(currentPage, totalPages) {
  const pages = [];

  if (currentPage > 3) {
    pages.push(1, '…');
  }

  const start = Math.max(1, currentPage - 2);
  const end = Math.min(totalPages, currentPage + 2);

  for (let i = start; i <= end; i++) {
    pages.push(i);
  }

  if (currentPage < totalPages - 2) {
    pages.push('…', totalPages);
  }

  return pages;
}

export const Pagination = ({ currentPage, count, onSelectCallback }) => {
  const totalPages = Math.ceil(count / PAGINATION_PAGE);
  const pages = getPageNumbers(currentPage, totalPages);
  return (
    <PaginationContainer>
      <StyledButton
        onClick={() => onSelectCallback(currentPage - 1)}
        disabled={currentPage === 1}
      >
        <Icon>{'ExpandLeft'}</Icon>
      </StyledButton>

      {pages.map(page => (
        <StyledButton
          key={page}
          isActive={currentPage === page}
          onClick={() => (page !== '…' ? onSelectCallback(page) : {})}
        >
          {page}
        </StyledButton>
      ))}

      <StyledButton
        onClick={() => onSelectCallback(currentPage + 1)}
        disabled={currentPage === totalPages}
      >
        <Icon>{'ExpandRight'}</Icon>
      </StyledButton>
    </PaginationContainer>
  );
};
